// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 279 ? "b1644e8c" : chunkId) + "." + {"68":"d7ffcfa2daff062d","279":"f4033ea1ac5af312"}[chunkId] + ".js";
};